import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, Card, Select, message } from 'antd';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import { LocalPersistence } from '../../../factories';
import { addOtherAcceptedPayments } from '../../../services/otherPayments';
import PageContainer from '../../CSIComponents/PageContainer';
import Loading from '../../Loading';

const { Option } = Select;
const AddOtherAcceptedPayments = (props: any) => {
  const [disableFlag, setDisableFlag] = useState(true);
  const [form] = Form.useForm();
  const [addLoading, setAddLoading] = useState(false)
  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const validateForm = ()=>{
    form.validateFields().then(()=>{
        setDisableFlag(false)
    }).catch(err=>{
        err.errorFields.length?setDisableFlag(true):setDisableFlag(false)
    });
  }

  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()
      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "otherpayments": {
            "otheracceptedpayments": [
              {
                ...value,
              }
            ]
          }
        }
      }
      setAddLoading(true)
      const res = await addOtherAcceptedPayments(params);
      if(res.result.success){
        form.resetFields();
        props.cancelAddAndEdit();
      }else{
        message.error({
          content: res?.errors[0]?.message
        });
      }
      setAddLoading(false)

    })
  }

  if (addLoading) return <Loading type='large' />
  return (
    <PageContainer>
      <Card className='db-page'>
        <Grid container spacing={0} className='py-0'>
          <Grid item xs={12} className='p-0'>
            <div className='db-title-wrap'>
              <div className='db-title'>Other Accepted Payments</div>
            </div>
          </Grid>
          <Grid item xs={12} className='db-content-wrap pb-0 px-0 my-0'>
            <Form
              layout='vertical'
              form={form}
              name='basic'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onValuesChange={validateForm}>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item label='Payment Type' name='paytype'>
                    <Select allowClear showSearch>
                      <Option value='Certificates/Awards'>
                        Certificates/Awards
                      </Option>
                      <Option value='Guarantee For Late Arrival'>
                        Guarantee For Late Arrival
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label='Use For Guarantee' name='useforguarantee'>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='usefordeposit' label='Use For Deposit'>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
                <Col span={6}>
                  <Form.Item label='Use For Payment' name='useforpayment'>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onCancel={() => {
          props.cancelAddAndEdit()
          form.resetFields()
        }}
        onSave={addSave}
        disabledSave={disableFlag}
      />
    </PageContainer>
  )
}
export default AddOtherAcceptedPayments;
